import { BaseDataTransferObject } from './base-data-transfer-object';

export class RequisitionSignature extends BaseDataTransferObject {
    public signatureImageId?: number;
    public requisitionId?: number;
    public signature?: Signature;
    public signedDateTime?: Date;
}

export class Signature extends BaseDataTransferObject {
    public imageSignature?: string;
    public userName?: string;
    public isUserLis: boolean = false;
}

export class MultipleRequisitionsSignature {
    public requisitionsIds?: number[];
    public username?: string;
    public image?: string;
}

export class OrderSignature extends BaseDataTransferObject {
  public signatureImageId?: number;
  public orderId?: number;
  public signature?: Signature;
  public signedDateTime?: Date;
}

export class MultipleOrdersSignature {
  public ordersIds?: number[];
  public username?: string;
  public image?: string;
}
